// converted using https://react-svgr.com/playground/?jsxRuntime=classic

import * as React from "react"
const BackgroundComponent = React.memo((props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 127 127"
    {...props}
  >
    <defs>
      <linearGradient id="a">
        <stop
          offset={0}
          style={{
            stopColor: "#aaa",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#fff",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        xlinkHref="#a"
        id="b"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="d"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="e"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="f"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="g"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="i"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="r"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="s"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="t"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="u"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="v"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="j"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="k"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="l"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="m"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="n"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="o"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="p"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="q"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="x"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="y"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="z"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="A"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="C"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="D"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="h"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#a"
        id="B"
        x1={47.672}
        x2={47.926}
        y1={79.962}
        y2={-1.271}
        gradientUnits="userSpaceOnUse"
      />
      <filter
        id="c"
        width={1}
        height={1}
        x={0}
        y={0}
        style={{
          colorInterpolationFilters: "sRGB",
        }}
      >
        <feFlood floodColor="#393939" floodOpacity={1} result="flood1" />
        <feBlend in="flood1" in2="SourceGraphic" result="blend1" />
        <feComposite in="blend1" in2="SourceGraphic" operator="in" />
      </filter>
      <filter
        id="w"
        width={1}
        height={1}
        x={0}
        y={0}
        style={{
          colorInterpolationFilters: "sRGB",
        }}
      >
        <feFlood floodColor="#777" floodOpacity={1} result="flood1" />
        <feBlend in="flood1" in2="SourceGraphic" result="blend1" />
        <feComposite
          in="blend1"
          in2="SourceGraphic"
          operator="in"
          result="fbSourceGraphic"
        />
        <feColorMatrix
          in="fbSourceGraphic"
          result="fbSourceGraphicAlpha"
          values="0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
        />
        <feFlood floodColor="#777" floodOpacity={1} result="flood1" />
        <feBlend in="flood1" in2="fbSourceGraphic" result="blend1" />
        <feComposite in="blend1" in2="fbSourceGraphic" operator="in" />
      </filter>
    </defs>
    <g
      style={{
        filter: "url(#c)",
      }}
    >
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#d)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 75.623 21.995)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 22.061 -29.47)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#e)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 69.737 139.332)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 69.601 -5.327)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#f)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 -62.635 72.499)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 19.262 41.056)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#g)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 -32.664 233.02)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 90.816 57.237)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#h)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.72236 .75106) rotate(45 -29.687 156.132)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.72198 -.02432 .0234 .75066 73.47 50.112)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#i)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 96.194 210.061)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 103.4 -4.069)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#j)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 153.564 196.726)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 107.715 -31.935)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#k)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 133.719 134.12)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 78.41 -34.632)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#l)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 63.006 245.533)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 112.39 17.145)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#m)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 -41.023 302.963)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 118.322 73.777)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#n)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 -113.17 104.294)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 23.757 69.282)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#o)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 -143.92 65.324)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 2.363 75.754)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#p)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 -136.76 168.814)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 46.41 91.575)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#q)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 -67.805 39.445)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 4.7 37.281)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#r)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 -61.665 169.862)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 59.713 58.495)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#s)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 93.213 73.556)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 46.41 -27.8)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#t)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 -4.41 47.512)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 18.903 10.673)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#u)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 8.168 159.185)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 67.264 25.595)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#v)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.58514 .62659) rotate(45 32.524 100.432)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.58483 -.0203 .01895 .62626 47.128 4.021)"
        />
      </g>
    </g>
    <g
      style={{
        filter: "url(#w)",
      }}
    >
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#x)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.72236 .75106) rotate(45 71.29 32.32)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.72198 -.02432 .0234 .75066 31.592 -30.751)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#y)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.72236 .75106) rotate(45 23.228 108.168)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.72198 -.02432 .0234 .75066 60.166 11.459)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#z)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.72236 .75106) rotate(45 -36.093 58.122)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.72198 -.02432 .0234 .75066 22.052 31.954)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#A)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.72236 .75106) rotate(45 -39.46 189.746)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.72198 -.02432 .0234 .75066 88.571 62.697)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#B)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.72236 .75106) rotate(45 29.853 189.545)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.72198 -.02432 .0234 .75066 103.133 25.842)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#C)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.72236 .75106) rotate(45 90.039 165.671)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.72198 -.02432 .0234 .75066 103.673 -11.373)"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M47.381 1.907h.817v78.397h-.817z"
          style={{
            fill: "url(#D)",
            fillOpacity: 1,
            strokeWidth: 0.0643649,
          }}
          transform="scale(.72236 .75106) rotate(45 77.276 70.294)"
        />
        <path
          d="M-26.511 89.36h1.017v1.011h-1.017z"
          style={{
            fill: "#fff",
            strokeWidth: 0.018845,
          }}
          transform="matrix(.72198 -.02432 .0234 .75066 52.255 -25.576)"
        />
      </g>
    </g>
  </svg>
))
export default BackgroundComponent
